module.exports = __webpack_public_path__ + "img/spin_btn.7d0e55f9.png";